import { CompanyRecord } from '@monorepo/deprecated/core/records'

export const ReducerRecord = CompanyRecord
